// Lib
import React from 'react';
import {
  BookOpen,
  Dumbbell,
  Gem,
  Home,
  Laptop,
  Newspaper,
  Plane,
  UtensilsCrossed,
} from 'lucide-react';

// Components
import { SelectableCard } from './SelectableCard';

// Types
import type { OrganizationAnswers } from '../../model/useCreateOrganization';

interface IndustrySelectorProps {
  onChange: (name: string, value: string) => void;
  answers: OrganizationAnswers;
}

const INDUSTRY_OPTIONS: { label: string; Icon: typeof Gem }[] = [
  { label: 'Beauty, Fashion', Icon: Gem },
  { label: 'Media', Icon: Newspaper },
  { label: 'Sport', Icon: Dumbbell },
  { label: 'Travel', Icon: Plane },
  { label: 'Restaurant', Icon: UtensilsCrossed },
  { label: 'Tech, Gadgets', Icon: Laptop },
  { label: 'Home, Interior', Icon: Home },
  { label: 'Education', Icon: BookOpen },
];

export const IndustrySelector: React.FC<IndustrySelectorProps> = ({
  onChange,
  answers,
}) => (
  <div className="mb-2 grid grid-cols-2 gap-2">
    {INDUSTRY_OPTIONS.map(({ label, Icon }) => (
      <SelectableCard
        key={label}
        active={answers?.industry === label}
        onClick={() => {
          if (answers?.industryOwn) onChange('industryOwn', '');
          onChange('industry', label);
        }}
        className="w-full"
      >
        <Icon className="size-5 text-foreground" />
        <p className="text-sm text-foreground">{label}</p>
      </SelectableCard>
    ))}
  </div>
);
